module.exports = __webpack_public_path__ + "assets/img/instagram.b0c05b13.webp";